const SUPERADMIN_MARKER = 'superadmin';

/**
 * Mirrors the server-side check in `SuperadminAccounts` (control-plane).
 *
 * The per-organisation superadmin accounts hold AIBUILD_ADMIN so that CAM grants
 * them SUPER_ADMIN, but they are shared with customers and must never reach the
 * back office. The back office is also blocked server-side; this only avoids
 * rendering a shell whose every request would 403.
 */
export const isSuperadminAccount = (email?: string | null): boolean =>
  !!email && email.toLowerCase().includes(SUPERADMIN_MARKER);
